// Stored refs end with `<card_brand>-<hash>-<file name>`, e.g. `visa-<sha256>-resumen.pdf.gz`.
const HASH_PREFIX = /^[^-]+-[0-9a-f]{32,64}-/i;
// card-front manual uploads prefix the original filename with the upload time.
const UPLOAD_TIME_PREFIX = /^\d{6}_/;

/**
 * Original file name from a scraper document storage ref.
 *
 * Refs look like
 * `country/document_type/info_provider/yyyy/mm/dd/credential_id/establishment/<card_brand>-<hash>-<file>`.
 * Older refs may not follow it, so the last path segment is the fallback.
 */
export const documentFileName = (documentStorageRef) => {
  const storagePath = String(documentStorageRef || '').split('/');
  const storedName = storagePath.pop();

  if (!storedName) {
    return '-';
  }

  const hashPrefixed = HASH_PREFIX.test(storedName);
  const cardFrontUpload =
    storagePath.length === 6 &&
    /^\d{4}$/.test(storagePath[3]) &&
    /^\d{2}$/.test(storagePath[4]) &&
    /^\d{2}$/.test(storagePath[5]);
  const cleanName = hashPrefixed
    ? storedName.replace(HASH_PREFIX, '')
    : cardFrontUpload
      ? storedName.replace(UPLOAD_TIME_PREFIX, '')
      : storedName;

  return cleanName || storedName;
};
